import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Toast, ToastContainer, Spinner, Form, ListGroup, Badge, Image } from 'react-bootstrap';
import { FaTrash, FaPlus, FaEdit, FaRedo, FaImages, FaMapMarkerAlt, FaRoad, FaSave, FaTimes, FaArrowLeft, FaCamera, FaLayerGroup, FaCheck } from 'react-icons/fa';
import {
  getNeighborhoodDevelopments,
  deleteNeighborhoodDevelopment,
  getNeighborhoodDevelopmentByGuid,
  updateNeighborhoodDevelopment,
  addNeighborhoodDevelopment,
  getIskenderunNeighborhoods,
  getIskenderunStreets
} from '../../services/neighborhoodService';

// ── Arc UI Tasarım Stilleri ────
const modernStyles = {
  pageContainer: {
    background: 'transparent',
    minHeight: 'auto',
    padding: 0
  },
  headerCard: {
    background: 'var(--arc-surface)',
    border: '1px solid var(--arc-border)',
    borderRadius: 'var(--arc-radius-lg)',
    boxShadow: 'var(--arc-shadow-sm)',
    color: 'var(--arc-text-primary)'
  },
  sidebarCard: {
    borderRadius: 'var(--arc-radius-lg)',
    border: '1px solid var(--arc-border)',
    boxShadow: 'var(--arc-shadow-sm)',
    background: 'var(--arc-surface)',
    overflow: 'hidden'
  },
  sidebarHeader: {
    background: 'var(--arc-surface-subtle)',
    border: 'none',
    borderBottom: '1px solid var(--arc-border)',
    padding: '1rem 1.25rem',
    fontSize: '0.95rem',
    fontWeight: 700,
    color: 'var(--arc-text-primary)',
    letterSpacing: '-0.01em'
  },
  sidebarItem: {
    border: 'none',
    borderBottom: '1px solid var(--arc-border-subtle)',
    transition: 'all 0.15s ease',
    padding: '0.85rem 1.25rem',
    background: 'transparent',
    color: 'var(--arc-text-primary)'
  },
  sidebarItemActive: {
    background: 'var(--arc-primary-subtle)',
    border: 'none',
    borderBottom: '1px solid transparent',
    color: 'var(--arc-primary)',
    fontWeight: 600
  },
  categoryCard: {
    borderRadius: 'var(--arc-radius-lg)',
    border: '1px solid var(--arc-border)',
    background: 'var(--arc-surface)',
    overflow: 'hidden',
    boxShadow: 'var(--arc-shadow-sm)',
    transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)',
    cursor: 'default'
  },
  categoryCardHover: {
    transform: 'translateY(-3px)',
    boxShadow: 'var(--arc-shadow-md)',
    borderColor: 'rgba(59, 130, 246, 0.35)'
  },
  cardImageOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(transparent, rgba(15, 23, 42, 0.85))',
    padding: '2rem 1rem 0.75rem',
    color: '#fff'
  },
  photoBadge: {
    background: 'rgba(15, 23, 42, 0.65)',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(255,255,255,0.2)',
    color: '#fff',
    borderRadius: '9999px',
    padding: '4px 10px',
    fontSize: '0.75rem',
    fontWeight: 600
  },
  streetBadge: {
    background: 'var(--arc-primary-subtle)',
    border: '1px solid rgba(37, 99, 235, 0.25)',
    borderRadius: '9999px',
    padding: '4px 12px',
    fontSize: '0.75rem',
    fontWeight: 600,
    color: 'var(--arc-primary-text)'
  },
  pendingBadge: {
    background: 'var(--arc-warning-subtle)',
    border: '1px solid rgba(245, 158, 11, 0.25)',
    borderRadius: '9999px',
    padding: '4px 12px',
    fontSize: '0.75rem',
    fontWeight: 600,
    color: 'var(--arc-warning-text)'
  },
  editBtn: {
    borderRadius: 'var(--arc-radius-md)',
    border: '1px solid rgba(37, 99, 235, 0.3)',
    color: 'var(--arc-primary)',
    background: 'var(--arc-primary-subtle)',
    fontWeight: 500,
    fontSize: '0.8125rem',
    transition: 'all 0.15s ease'
  },
  deleteBtn: {
    borderRadius: 'var(--arc-radius-md)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    color: 'var(--arc-danger)',
    background: 'var(--arc-danger-subtle)',
    fontWeight: 500,
    fontSize: '0.8125rem',
    transition: 'all 0.15s ease'
  },
  addBtn: {
    background: 'linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%)',
    border: '1px solid #1d4ed8',
    borderRadius: 'var(--arc-radius-md)',
    fontWeight: 600,
    padding: '0.5rem 1.25rem',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.12)',
    transition: 'all 0.15s ease',
    color: '#fff'
  },
  refreshBtn: {
    borderRadius: 'var(--arc-radius-md)',
    border: '1px solid var(--arc-border)',
    background: 'var(--arc-surface-subtle)',
    color: 'var(--arc-text-secondary)',
    fontWeight: 500,
    padding: '0.5rem 1rem'
  },
  emptyState: {
    borderRadius: 'var(--arc-radius-lg)',
    border: '1px dashed var(--arc-border)',
    boxShadow: 'none',
    background: 'var(--arc-surface)',
    color: 'var(--arc-text-secondary)'
  }
};


// ── Yardımcı Fonksiyonlar ──────────────────────────────────────────────
const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('blob:')) return url;
  if (url.startsWith('/assets/')) return `https://iskenderun.bel.tr${url}`;
  if (url.startsWith('/uploads/')) {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';
    const apiDomain = apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
    return `${apiDomain}${url}`;
  }
  return `https://iskenderun.bel.tr${url.startsWith('/') ? url : '/' + url}`;
};

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const replaceTurkishChars = (value) =>
  value
    .replace(/İ/g, 'I').replace(/I/g, 'I').replace(/ı/g, 'i')
    .replace(/Ğ/g, 'G').replace(/ğ/g, 'g')
    .replace(/Ü/g, 'U').replace(/ü/g, 'u')
    .replace(/Ş/g, 'S').replace(/ş/g, 's')
    .replace(/Ö/g, 'O').replace(/ö/g, 'o')
    .replace(/Ç/g, 'C').replace(/ç/g, 'c');

const generateSlug = (text) =>
  replaceTurkishChars(text || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^-a-zA-Z0-9\s]+/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .toLowerCase();

const normalizeMahalleName = (value) => {
  const normalized = (value || '')
    .replace(/ Mahallesi/i, '')
    .replace(/ı/g, 'i')
    .replace(/İ/g, 'I')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
  return normalized === 'kavakliolu' ? 'kavaklioluk' : normalized;
};

const getAssignedMahalleFromToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return '';
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.assigned_mahalle || payload.assignedMahalle || '';
  } catch {
    return '';
  }
};

const fallbackMahalleler = [
  { name: 'Barbaros Mahallesi', image: '/assets/images/mahalleler/barbaros/1.jpg' },
  { name: 'Cumhuriyet Mahallesi', image: '/assets/images/mahalleler/cumhuriyet/1.jpg' },
  { name: 'Denizciler Mahallesi', image: '/assets/images/mahalleler/denizciler/1.jpg' },
  { name: 'Gültepe Mahallesi', image: '/assets/images/mahalleler/gultepe/1.jpg' },
  { name: 'İsmet İnönü Mahallesi', image: '/assets/images/mahalleler/ismet-inonu/1.jpg' },
  { name: 'Akçay Mahallesi', image: '/assets/images/mahalleler/akcay/1.jpg' },
  { name: 'Azganlık Mahallesi', image: '/assets/images/mahalleler/azganlik/1.jpg' },
  { name: 'Aşkarbeyli Mahallesi', image: '/assets/images/mahalleler/askarbeyli/1.jpg' },
  { name: 'Bekbele Mahallesi', image: '/assets/images/mahalleler/bekbele/1.jpg' },
  { name: 'Büyükdere Mahallesi', image: '/assets/images/mahalleler/buyukdere/1.jpg' },
  { name: 'Cebike Mahallesi', image: '/assets/images/mahalleler/cebike/1.jpg' },
  { name: 'Dumlupınar Mahallesi', image: '/assets/images/mahalleler/dumlupinar/1.jpg' },
  { name: 'Esentepe Mahallesi', image: '/assets/images/mahalleler/esentepe/1.jpg' },
  { name: 'Fatih Sultan Mehmet Mahallesi', image: '/assets/images/mahalleler/fatih-sultan-mehmet/1.jpg' },
  { name: 'Gürsel Mahallesi', image: '/assets/images/mahalleler/gursel/1.jpg' },
  { name: 'Kocatepe Mahallesi', image: '/assets/images/mahalleler/kocatepe/1.jpg' },
  { name: 'Numune Mahallesi', image: '/assets/images/mahalleler/numune/1.jpg' },
  { name: 'Sariseki Mahallesi', image: '/assets/images/mahalleler/sariseki/1.jpg' },
  { name: 'Süleymaniye Mahallesi', image: '/assets/images/mahalleler/suleymaniye/1.jpg' },
  { name: 'Çay Mahallesi', image: '/assets/images/mahalleler/cay/1.jpg' }
];

const resolveMahalleCoverImage = (mName, dataList = []) => {
  const cleanSelected = (mName || '').replace(/ Mahallesi/i, '').toLowerCase().replace(/i̇/g, 'i').trim();
  const matchedItem = dataList.find(item => {
    if (!item?.name) return false;
    const cleanItemName = item.name.replace(/ Mahallesi/i, '').toLowerCase().replace(/i̇/g, 'i').trim();
    return cleanItemName === cleanSelected || cleanItemName.includes(cleanSelected) || cleanSelected.includes(cleanItemName);
  });

  if (matchedItem) {
    if (matchedItem.coverImage) return getImageUrl(matchedItem.coverImage);
    if (Array.isArray(matchedItem.categories) && matchedItem.categories.length > 0) {
      for (const cat of matchedItem.categories) {
        if (Array.isArray(cat.images) && cat.images.length > 0 && cat.images[0].imageUrl) {
          return getImageUrl(cat.images[0].imageUrl);
        }
      }
    }
    if (Array.isArray(matchedItem.images) && matchedItem.images.length > 0 && matchedItem.images[0].imageUrl) {
      return getImageUrl(matchedItem.images[0].imageUrl);
    }
  }

  const fallbackObj = fallbackMahalleler.find(f => f.name.toLowerCase().includes(cleanSelected)) || fallbackMahalleler[0];
  return getImageUrl(fallbackObj?.image || `/assets/images/mahalleler/${generateSlug(mName)}/1.jpg`);
};

// ── Ana Bileşen ────────────────────────────────────────────────────────
const NeighborhoodList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Mahalle listesi ve seçim
  const [mahalleOptions, setMahalleOptions] = useState([]);
  const [selectedMahalle, setSelectedMahalle] = useState('');

  // Kullanıcı bilgileri
  const [userRole, setUserRole] = useState('admin');
  const [userAssignedMahalle, setUserAssignedMahalle] = useState('');

  // Modal state'leri
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingParentItem, setEditingParentItem] = useState(null);

  const [addModalVisible, setAddModalVisible] = useState(false);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deletingCategory, setDeletingCategory] = useState(null);
  const [deletingParentItem, setDeletingParentItem] = useState(null);

  // Toast
  const [toastState, setToastState] = useState({ show: false, message: '', variant: 'success' });
  const showToast = (message, variant = 'success') => setToastState({ show: true, message, variant });
  const hideToast = () => setToastState((prev) => ({ ...prev, show: false }));

  // ── Kullanıcı Rolü ve Otomatik Mahalle Seçimi ──
  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const u = JSON.parse(userStr);
        const role = (u.userType || u.role || u.Role || 'admin').toLowerCase().trim();
        const emailNeighborhood = role === 'muhtar'
          ? (u.email || '').match(/^muhtar[_-]([^@]+)@/i)?.[1] || ''
          : '';
        const assigned = u.assignedMahalle
          || u.assignedNeighborhood
          || u.AssignedMahalle
          || u.assigned_mahalle
          || getAssignedMahalleFromToken()
          || emailNeighborhood;
        setUserRole(role);
        setUserAssignedMahalle(assigned);

        if (role === 'muhtar' && assigned) {
          setSelectedMahalle(assigned);
        }
      } catch (e) {}
    }
  }, []);

  // ── Mahalle Listesi ──
  useEffect(() => {
    const fetchMahalles = async () => {
      try {
        const list = await getIskenderunNeighborhoods();
        const availableMahalles = list || [];
        const assignedOption = userRole === 'muhtar' && userAssignedMahalle
          ? availableMahalles.find((name) => normalizeMahalleName(name) === normalizeMahalleName(userAssignedMahalle))
          : null;

        if (assignedOption && assignedOption !== userAssignedMahalle) {
          setUserAssignedMahalle(assignedOption);
          setSelectedMahalle(assignedOption);
        }

        setMahalleOptions(
          userRole === 'muhtar'
            ? [assignedOption || userAssignedMahalle].filter(Boolean)
            : availableMahalles
        );
      } catch (e) {
        const uniqueMahalles = Array.from(new Set(data.map((item) => item.name).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'tr'));
        setMahalleOptions(userRole === 'muhtar' ? [userAssignedMahalle].filter(Boolean) : uniqueMahalles);
      }
    };
    fetchMahalles();
  }, [data, userRole, userAssignedMahalle]);

  // ── Veri Çekme ──
  const fetchData = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await getNeighborhoodDevelopments();
      if (response?.isSuccess && Array.isArray(response.data)) {
        setData(response.data);
      } else {
        throw new Error(response?.resultMessage ?? 'Beklenmeyen bir sonuç alındı.');
      }
    } catch (err) {
      console.error('Error while fetching data:', err);
      setData([]);
      setError('Veriler yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // ── Seçilen Mahallenin Verileri ──
  const visibleData = userRole === 'muhtar'
    ? data.filter((item) => normalizeMahalleName(item.name) === normalizeMahalleName(userAssignedMahalle))
    : data;
  const selectedMahalleItems = visibleData.filter((item) => normalizeMahalleName(item.name) === normalizeMahalleName(selectedMahalle));

  // Kategorileri düzleştir: her kategoriyi parent item'ıyla birlikte göster
  const allCategoriesForMahalle = selectedMahalleItems.flatMap((item) =>
    (item.categories || []).map((cat) => ({
      ...cat,
      parentGuid: item.guid,
      parentName: item.name,
      parentUrlTag: item.urlTag,
      parentTitle: item.title,
      parentIsApproved: item.isApproved,
      parentCreatedByRole: item.createdByRole,
      // Kapak resmi: kategorinin ilk fotoğrafı
      coverImage: Array.isArray(cat.images) && cat.images.length > 0
        ? getImageUrl(cat.images[0].imageUrl)
        : (item.coverImage ? getImageUrl(item.coverImage) : null)
    }))
  );

  // Mahalle başına kategori sayısı
  const getCategoryCount = (mahalleName) => {
    return visibleData
      .filter((item) => item.name === mahalleName)
      .reduce((sum, item) => sum + (item.categories?.length || 0), 0);
  };

  // Mahalle başına fotoğraf sayısı
  const getPhotoCount = (mahalleName) => {
    return visibleData
      .filter((item) => item.name === mahalleName)
      .reduce((sum, item) => sum + (item.totalImages || 0), 0);
  };

  // ── Kategori Düzenleme ──
  const handleEditCategory = (category, parentItem) => {
    setEditingCategory(category);
    setEditingParentItem(parentItem);
    setEditModalVisible(true);
  };

  // ── Kategori Silme ──
  const handleDeleteCategory = (category, parentItem) => {
    setDeletingCategory(category);
    setDeletingParentItem(parentItem);
    setDeleteModalVisible(true);
  };

  const confirmDeleteCategory = async () => {
    if (!deletingCategory || !deletingParentItem) return;
    try {
      // Parent item'ı al, bu kategoriyi çıkar, güncelle
      const detailResponse = await getNeighborhoodDevelopmentByGuid(deletingParentItem.guid);
      if (!detailResponse?.isSuccess || !detailResponse.data) {
        throw new Error('Detay alınamadı.');
      }
      const fullItem = detailResponse.data;
      const updatedCategories = (fullItem.categories || [])
        .filter((c) => c.guid !== deletingCategory.guid)
        .map((c, idx) => ({
          guid: c.guid,
          name: c.name,
          description: c.description || '',
          sortOrder: idx + 1,
          existingImageGuids: (c.images || []).map((img) => img.guid),
          galleryImagesBase64: []
        }));

      const payload = {
        guid: fullItem.guid,
        name: fullItem.name,
        sokakName: fullItem.sokakName || null,
        urlTag: fullItem.urlTag,
        title: fullItem.title || '',
        description: fullItem.description || '',
        categories: updatedCategories,
        existingImageGuids: [],
        galleryImagesBase64: [],
        isApproved: fullItem.isApproved ?? true,
        createdByRole: fullItem.createdByRole || userRole
      };

      const res = await updateNeighborhoodDevelopment(payload);
      if (res?.isSuccess) {
        showToast('Kategori başarıyla silindi.');
        fetchData();
      } else {
        throw new Error(res?.resultMessage || 'Silme başarısız.');
      }
    } catch (err) {
      console.error('Delete category error:', err);
      showToast('Kategori silinirken hata oluştu.', 'danger');
    } finally {
      setDeleteModalVisible(false);
      setDeletingCategory(null);
      setDeletingParentItem(null);
    }
  };

  // ── Yeni Ekleme Başarı ──
  const handleAddSuccess = async () => {
    await fetchData();
    setAddModalVisible(false);
    showToast('Başarıyla eklendi.');
  };

  // ── Düzenleme Başarı ──
  const handleEditSuccess = async () => {
    await fetchData();
    setEditModalVisible(false);
    setEditingCategory(null);
    setEditingParentItem(null);
    showToast('Başarıyla güncellendi.');
  };

  // ── RENDER ──────────────────────────────────────────────────────────
  return (
    <div style={modernStyles.pageContainer}>
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast show={toastState.show} onClose={hideToast} bg={toastState.variant} delay={3000} autohide>
          <Toast.Body className="text-white">{toastState.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      {/* Üst Başlık (Standart Arc UI Header) */}
      <div className="arc-page-header">
        <div>
          <h2>Mahallem Gelişiyor</h2>
          <p>Sahadan çalışma ve sokak düzenlemeleri yönetim paneli</p>
        </div>
        <div className="d-flex gap-2 mt-2 mt-md-0">
          <Button
            variant="outline-secondary"
            onClick={fetchData}
            disabled={loading}
          >
            <FaRedo className="me-2" /> Yenile
          </Button>
          {selectedMahalle && (
            <Button variant="primary" onClick={() => setAddModalVisible(true)}>
              <FaPlus className="me-2" /> Yeni Kategori Ekle
            </Button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner animation="border" role="status" style={{ color: '#667eea' }}>
            <span className="visually-hidden">Yükleniyor...</span>
          </Spinner>
        </div>
      ) : error ? (
        <div className="text-center py-5 text-danger fw-semibold">{error}</div>
      ) : (
        <Row>
          {/* ── Tam Genişlik Ana İçerik Alanı ── */}
          <Col xs={12}>
            {!selectedMahalle ? (
              <div>
                <Row className="g-3">
                  {(() => {
                    let listToRender = mahalleOptions;
                    if (userRole === 'muhtar') {
                      listToRender = userAssignedMahalle
                        ? mahalleOptions.filter((name) => normalizeMahalleName(name) === normalizeMahalleName(userAssignedMahalle))
                        : [];
                    }
                    return listToRender;
                  })().map((mName, idx) => {
                    const catCount = getCategoryCount(mName);
                    const photoCount = getPhotoCount(mName);
                    const coverImg = resolveMahalleCoverImage(mName, data);

                    return (
                      <Col key={mName} xs={12} md={6} lg={4} xl={3}>
                        <div
                          className="mahalle-card shadow-sm h-100 bg-white rounded-4 overflow-hidden d-flex flex-column"
                          style={{ cursor: 'pointer', border: '1px solid #eef1f5', transition: 'all 0.25s ease' }}
                          onClick={() => setSelectedMahalle(mName)}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 77, 140, 0.15)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)';
                          }}
                        >
                          <div style={{ height: '220px', position: 'relative', overflow: 'hidden', backgroundColor: '#003a6b' }}>
                            <img
                              src={coverImg}
                              alt={mName}
                              onError={(e) => { e.target.onerror = null; e.target.src = 'https://iskenderun.bel.tr/assets/images/default-image.jpg'; }}
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          </div>
                          <div className="p-3 d-flex flex-column flex-grow-1">
                            <h4 className="fw-bold text-dark mb-2" style={{ fontSize: '1.2rem' }}>{mName}</h4>
                            <p className="text-secondary small mb-0" style={{ lineHeight: 1.5 }}>
                              {catCount > 0
                                ? `Mahalleye ait ${catCount} kategori ve ${photoCount} fotoğraf kayıtlı.`
                                : 'Mahalledeki sahadan çalışma görsellerini ve sokak düzenlemelerini yönetmek için tıklayınız.'}
                            </p>
                            <div className="d-flex align-items-center justify-content-between mt-auto pt-3 border-top">
                              <span className="fw-bold" style={{ color: '#004d8c' }}>Çalışmaları Yönet</span>
                              <FaArrowLeft style={{ transform: 'rotate(180deg)', color: '#004d8c' }} />
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            ) : (
              <div>
                <div
                  className="d-flex align-items-center justify-content-between mb-4 p-3 px-4 rounded-4 shadow-sm bg-white border-0"
                  style={{ borderLeft: '5px solid #004d8c' }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      style={{
                        width: '44px',
                        height: '44px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(0, 77, 140, 0.1)',
                        color: '#004d8c',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.2rem'
                      }}
                    >
                      <FaMapMarkerAlt />
                    </div>
                    <div>
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <h5 className="fw-bold mb-0 text-dark" style={{ fontSize: '1.15rem' }}>{selectedMahalle}</h5>
                        <Badge bg="primary" pill className="px-3 py-1" style={{ backgroundColor: '#004d8c', fontSize: '0.75rem' }}>
                          {allCategoriesForMahalle.length} Kategori
                        </Badge>
                      </div>
                      <small className="text-secondary fw-semibold">Mahalleye ait sahadan düzenleme ve çalışma kategorileri</small>
                    </div>
                  </div>
                  <Button
                    variant="outline-primary"
                    className="rounded-pill px-4 py-2 fw-bold btn-sm shadow-sm"
                    style={{
                      color: 'var(--arc-primary)',
                      borderColor: 'var(--arc-border)',
                      backgroundColor: 'var(--arc-surface)',
                      cursor: 'pointer'
                    }}
                    onClick={() => setSelectedMahalle('')}
                  >
                    ← Tüm Mahallelere Dön
                  </Button>
                </div>

                {allCategoriesForMahalle.length === 0 ? (
                  <Card style={modernStyles.emptyState}>
                    <Card.Body className="text-center py-5">
                      <div style={{
                        width: 80, height: 80, borderRadius: '50%',
                        background: 'rgba(26, 117, 188, 0.1)',
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        marginBottom: '1.5rem'
                      }}>
                        <FaImages size={32} style={{ color: '#1a75bc' }} />
                      </div>
                      <h5 style={{ color: '#444', fontWeight: 600 }}>Bu mahallede henüz kategori yok</h5>
                      <p className="text-muted mb-3">Sağ üstteki "Yeni Kategori Ekle" butonuyla ekleme yapabilirsiniz.</p>
                      <Button onClick={() => setAddModalVisible(true)} style={modernStyles.addBtn}>
                        <FaPlus className="me-2" /> İlk Kategoriyi Ekle
                      </Button>
                    </Card.Body>
                  </Card>
                ) : (
                  <Row className="g-3">
                {allCategoriesForMahalle.map((cat) => {
                  const parentItem = selectedMahalleItems.find((i) => i.guid === cat.parentGuid);
                  return (
                    <Col key={cat.guid} xs={12} sm={6} md={4} xl={3}>
                      <Card
                        className="h-100 category-card-hover"
                        style={modernStyles.categoryCard}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-6px)';
                          e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                        }}
                      >
                        {/* Kapak Resmi */}
                        <div style={{ height: 200, background: 'linear-gradient(135deg, #e0e5ec 0%, #d0d5dc 100%)', position: 'relative', overflow: 'hidden' }}>
                          {cat.coverImage ? (
                            <img
                              src={cat.coverImage}
                              alt={cat.name}
                              style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s ease' }}
                            />
                          ) : (
                            <div className="d-flex flex-column align-items-center justify-content-center h-100" style={{ color: '#aaa' }}>
                              <FaCamera size={36} />
                              <small className="mt-2">Görsel yok</small>
                            </div>
                          )}
                          {/* Gradient overlay */}
                          <div style={modernStyles.cardImageOverlay}>
                            <div className="d-flex justify-content-between align-items-end">
                              <h6 className="mb-0 fw-bold" style={{ fontSize: '0.95rem', textShadow: '0 1px 3px rgba(0,0,0,0.5)' }}>
                                {cat.name}
                              </h6>
                              <span style={modernStyles.photoBadge}>
                                <FaCamera className="me-1" size={10} />
                                {cat.totalImages || 0}
                              </span>
                            </div>
                          </div>
                          {/* Onay durumu */}
                          {cat.parentIsApproved === false && (
                            <span
                              className="position-absolute"
                              style={{ ...modernStyles.pendingBadge, top: 10, left: 10 }}
                            >
                              Onay Bekliyor
                            </span>
                          )}
                        </div>

                        <Card.Body className="pb-2 pt-3 px-3">
                          {cat.sokakName && !['belirsiz', 'belirtilmedi', 'bilinmiyor', 'yok', 'tanımsız', 'null', 'undefined'].includes(cat.sokakName.trim().toLowerCase()) && (
                            <div className="mb-2">
                              <span style={modernStyles.streetBadge}>
                                <FaRoad className="me-1" size={10} />
                                {cat.sokakName}
                              </span>
                            </div>
                          )}
                          {cat.description && (
                            <p className="text-muted small mb-0" style={{ lineHeight: 1.4, fontSize: '0.82rem' }}>
                              {cat.description.length > 80
                                ? `${cat.description.substring(0, 80)}…`
                                : cat.description}
                            </p>
                          )}
                        </Card.Body>

                        <Card.Footer style={{ background: 'transparent', border: 'none', padding: '0 1rem 1rem' }}>
                          <div className="d-flex gap-2">
                            <Button
                              size="sm"
                              className="flex-grow-1"
                              style={modernStyles.editBtn}
                              onClick={() => handleEditCategory(cat, parentItem)}
                              onMouseEnter={(e) => { e.currentTarget.style.background = '#1a75bc'; e.currentTarget.style.color = '#fff'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#1a75bc'; }}
                            >
                              <FaEdit className="me-1" /> Düzenle
                            </Button>
                            <Button
                              size="sm"
                              style={modernStyles.deleteBtn}
                              onClick={() => handleDeleteCategory(cat, parentItem)}
                              onMouseEnter={(e) => { e.currentTarget.style.background = '#ff6b6b'; e.currentTarget.style.color = '#fff'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#ff6b6b'; }}
                            >
                              <FaTrash />
                            </Button>
                          </div>
                          {/* Onay butonu */}
                          {cat.parentIsApproved === false && ['admin', 'basin'].includes(userRole) && (
                            <Button
                              size="sm"
                              className="w-100 mt-2"
                              style={{
                                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                border: 'none',
                                borderRadius: '10px',
                                fontWeight: 600,
                                fontSize: '0.8rem'
                              }}
                              onClick={async () => {
                                try {
                                  const payload = { ...parentItem, isApproved: true };
                                  const res = await updateNeighborhoodDevelopment(payload);
                                  if (res?.isSuccess) {
                                    showToast('İçerik onaylandı ve sitede yayınlandı.');
                                    fetchData();
                                  }
                                } catch (e) {
                                  showToast('Onaylanırken hata oluştu.', 'danger');
                                }
                              }}
                            >
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                <FaCheck size={11} /> Onayla ve Yayınla
                              </span>
                            </Button>
                          )}
                        </Card.Footer>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
                )}
              </div>
            )}
          </Col>
        </Row>
      )}

      {/* ── Silme Onay Modalı ── */}
      <Modal show={deleteModalVisible} onHide={() => setDeleteModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Kategori Silme Onayı</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu kategoriyi silmek istediğinizden emin misiniz? <br />
          <strong>{deletingCategory?.name}</strong>
          {deletingCategory?.sokakName && (
            <span className="text-muted"> ({deletingCategory.sokakName})</span>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModalVisible(false)}>İptal</Button>
          <Button variant="danger" onClick={confirmDeleteCategory}>Sil</Button>
        </Modal.Footer>
      </Modal>

      {/* ── Kategori Düzenleme Modalı ── */}
      <Modal show={editModalVisible} onHide={() => { setEditModalVisible(false); setEditingCategory(null); }} size="lg" centered className="custom-admin-modal">
        <Modal.Header closeButton className="border-0 pb-0 px-4 pt-4">
          <Modal.Title className="fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: '1.25rem' }}>
            <div style={{ width: 38, height: 38, borderRadius: '10px', backgroundColor: 'rgba(0, 77, 140, 0.1)', color: '#004d8c', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' }}>
              <FaEdit />
            </div>
            <span>Kategori Düzenle: <strong style={{ color: '#004d8c' }}>{editingCategory?.name}</strong></span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-4" style={{ minHeight: '480px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          {editingCategory && editingParentItem && (
            <CategoryPhotoEditor
              category={editingCategory}
              parentItem={editingParentItem}
              onSuccess={handleEditSuccess}
              onCancel={() => setEditModalVisible(false)}
              userRole={userRole}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* ── Yeni Kategori Ekleme Modalı ── */}
      <Modal show={addModalVisible} onHide={() => setAddModalVisible(false)} size="lg" centered className="custom-admin-modal">
        <Modal.Header closeButton className="border-0 pb-0 px-4 pt-4">
          <Modal.Title className="fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: '1.25rem' }}>
            <div style={{ width: 38, height: 38, borderRadius: '10px', backgroundColor: 'rgba(0, 77, 140, 0.1)', color: '#004d8c', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' }}>
              <FaPlus />
            </div>
            <span>Yeni Kategori Ekle - <strong style={{ color: '#004d8c' }}>{selectedMahalle}</strong></span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-4">
          <NewCategoryForm
            mahalleName={selectedMahalle}
            existingItems={selectedMahalleItems}
            onSuccess={handleAddSuccess}
            onCancel={() => setAddModalVisible(false)}
            userRole={userRole}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════
// Alt Bileşen: Kategori Fotoğraf Düzenleyici
// ════════════════════════════════════════════════════════════════════════
const CategoryPhotoEditor = ({ category, parentItem, onSuccess, onCancel, userRole }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [catName, setCatName] = useState(category.name || '');
  const [catDescription, setCatDescription] = useState(category.description || '');
  const [catSokakName, setCatSokakName] = useState(category.sokakName || '');
  const [streetOptions, setStreetOptions] = useState([]);
  const [existingImages, setExistingImages] = useState(
    (category.images || []).map((img) => ({
      ...img,
      previewUrl: getImageUrl(img.imageUrl)
    }))
  );
  const [newImages, setNewImages] = useState([]);
  const [newPreviews, setNewPreviews] = useState([]);

  // Sokak listesini çek
  useEffect(() => {
    const fetchStreets = async () => {
      if (parentItem?.name) {
        const streets = await getIskenderunStreets(parentItem.name);
        setStreetOptions(streets || []);
      }
    };
    fetchStreets();
  }, [parentItem?.name]);

  const [isDragging, setIsDragging] = useState(false);

  const processFiles = async (files) => {
    if (!files || files.length === 0) return;
    const base64s = [];
    const previews = [];
    for (const file of files) {
      if (!file.type.startsWith('image/')) continue;
      base64s.push(await toBase64(file));
      previews.push(URL.createObjectURL(file));
    }
    setNewImages((prev) => [...prev, ...base64s]);
    setNewPreviews((prev) => [...prev, ...previews]);
  };

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    await processFiles(files);
    e.target.value = null;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files || []);
    await processFiles(files);
  };

  const removeExisting = (guid) => {
    setExistingImages((prev) => prev.filter((img) => img.guid !== guid));
  };

  const removeNew = (index) => {
    setNewImages((prev) => prev.filter((_, i) => i !== index));
    setNewPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    if (!catName.trim()) {
      setError('Kategori adı zorunludur.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const detailResponse = await getNeighborhoodDevelopmentByGuid(parentItem.guid);
      if (!detailResponse?.isSuccess || !detailResponse.data) {
        throw new Error('Detay alınamadı.');
      }
      const fullItem = detailResponse.data;

      const updatedCategories = (fullItem.categories || []).map((c, idx) => {
        if (c.guid === category.guid) {
          return {
            guid: c.guid,
            name: catName.trim(),
            sokakName: catSokakName || null,
            description: catDescription.trim(),
            sortOrder: idx + 1,
            existingImageGuids: existingImages.map((img) => img.guid),
            galleryImagesBase64: newImages
          };
        }
        return {
          guid: c.guid,
          name: c.name,
          sokakName: c.sokakName || null,
          description: c.description || '',
          sortOrder: idx + 1,
          existingImageGuids: (c.images || []).map((img) => img.guid),
          galleryImagesBase64: []
        };
      });

      const payload = {
        guid: fullItem.guid,
        name: fullItem.name,
        sokakName: fullItem.sokakName || null,
        urlTag: fullItem.urlTag,
        title: fullItem.title || '',
        description: fullItem.description || '',
        categories: updatedCategories,
        existingImageGuids: [],
        galleryImagesBase64: [],
        isApproved: fullItem.isApproved ?? true,
        createdByRole: fullItem.createdByRole || userRole
      };

      const res = await updateNeighborhoodDevelopment(payload);
      if (res?.isSuccess) {
        onSuccess();
      } else {
        throw new Error(res?.resultMessage || 'Güncelleme başarısız.');
      }
    } catch (err) {
      console.error(err);
      setError(err.message || 'Bir hata oluştu.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 justify-content-between">
      {error && <div className="alert alert-danger shadow-sm border-0 rounded-3 mb-3">{error}</div>}

      <Row className="g-3 mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label className="fw-bold text-dark small mb-1">Kategori Adı <span className="text-danger">*</span></Form.Label>
            <Form.Control
              value={catName}
              onChange={(e) => setCatName(e.target.value)}
              className="rounded-3 shadow-none border py-2"
              placeholder="Örn: Akarca Mahallesi"
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label className="fw-bold text-dark small mb-1"><FaRoad className="me-1 text-primary" /> Sokak / Cadde</Form.Label>
            <Form.Select
              value={catSokakName}
              onChange={(e) => setCatSokakName(e.target.value)}
              className="rounded-3 shadow-none border py-2"
            >
              <option value="">-- Sokak Seçiniz --</option>
              {streetOptions.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label className="fw-bold text-dark small mb-1">Açıklama</Form.Label>
            <Form.Control
              value={catDescription}
              onChange={(e) => setCatDescription(e.target.value)}
              className="rounded-3 shadow-none border py-2"
              placeholder="Çalışma özeti..."
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group className="mb-4">
        <Form.Label className="fw-bold text-dark small mb-1">Yeni Fotoğraf Yükle</Form.Label>
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          className={`p-4 border border-2 border-dashed rounded-4 text-center transition-all ${
            isDragging ? 'bg-primary bg-opacity-10 border-primary shadow-sm' : 'bg-light border-secondary border-opacity-25'
          }`}
          style={{ transition: 'all 0.25s ease' }}
        >
          <Form.Control type="file" accept="image/*" multiple onChange={handleUpload} className="d-none" id="edit-photo-upload" />
          <label htmlFor="edit-photo-upload" className="mb-0 cursor-pointer d-flex flex-column align-items-center justify-content-center" style={{ cursor: 'pointer' }}>
            <FaCamera size={32} className={`mb-2 ${isDragging ? 'text-primary' : 'text-secondary'}`} />
            <span className="fw-bold text-dark small">
              {isDragging ? 'Fotoğrafları Buraya Bırakın' : 'Fotoğraf seçmek veya sürükleyip bırakmak için tıklayın'}
            </span>
            <small className="text-muted mt-1">Birden fazla görsele (PNG, JPG, WEBP) izin verilir</small>
          </label>
        </div>
      </Form.Group>

      {/* Mevcut Fotoğraflar */}
      {existingImages.length > 0 && (
        <div className="mb-4">
          <div className="text-dark small mb-2 fw-bold d-flex align-items-center justify-content-between">
            <span>Mevcut Fotoğraflar</span>
            <Badge bg="secondary" pill>{existingImages.length}</Badge>
          </div>
          <div className="d-flex flex-wrap gap-2">
            {existingImages.map((img) => (
              <div key={img.guid} className="position-relative rounded-3 overflow-hidden shadow-sm border" style={{ width: 90, height: 90 }}>
                <Image src={img.previewUrl} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <button
                  type="button"
                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 p-0 rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{ width: 22, height: 22, fontSize: '11px', lineHeight: 1 }}
                  onClick={() => removeExisting(img.guid)}
                >
                  <FaTimes />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Yeni Fotoğraflar */}
      {newPreviews.length > 0 && (
        <div className="mb-4">
          <div className="text-dark small mb-2 fw-bold d-flex align-items-center justify-content-between">
            <span>Yeni Eklenecek Fotoğraflar</span>
            <Badge bg="primary" pill>{newPreviews.length}</Badge>
          </div>
          <div className="d-flex flex-wrap gap-2">
            {newPreviews.map((preview, idx) => (
              <div key={idx} className="position-relative rounded-3 overflow-hidden shadow-sm border border-primary" style={{ width: 90, height: 90 }}>
                <Image src={preview} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <button
                  type="button"
                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 p-0 rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{ width: 22, height: 22, fontSize: '11px', lineHeight: 1 }}
                  onClick={() => removeNew(idx)}
                >
                  <FaTimes />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
        <Button variant="light" className="rounded-pill px-4 border text-secondary fw-semibold" onClick={onCancel} disabled={saving}>İptal</Button>
        <Button style={{ backgroundColor: '#004d8c', borderColor: '#004d8c' }} className="rounded-pill px-4 fw-bold shadow-sm" onClick={handleSave} disabled={saving}>
          {saving ? <Spinner animation="border" size="sm" /> : <><FaSave className="me-2" /> Kaydet</>}
        </Button>
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════
// Alt Bileşen: Yeni Kategori Ekleme Formu
// ════════════════════════════════════════════════════════════════════════
const NewCategoryForm = ({ mahalleName, existingItems, onSuccess, onCancel, userRole }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [catName, setCatName] = useState('');
  const [catDescription, setCatDescription] = useState('');
  const [sokakName, setSokakName] = useState('');
  const [streetOptions, setStreetOptions] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [newPreviews, setNewPreviews] = useState([]);

  useEffect(() => {
    const fetchStreets = async () => {
      if (mahalleName) {
        const streets = await getIskenderunStreets(mahalleName);
        setStreetOptions(streets || []);
      }
    };
    fetchStreets();
  }, [mahalleName]);

  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const processFiles = async (files) => {
    if (!files || files.length === 0) return;
    const base64s = [];
    const previews = [];
    for (const file of files) {
      if (!file.type.startsWith('image/')) continue;
      base64s.push(await toBase64(file));
      previews.push(URL.createObjectURL(file));
    }
    setNewImages((prev) => [...prev, ...base64s]);
    setNewPreviews((prev) => [...prev, ...previews]);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files || []);
    await processFiles(files);
  };

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    await processFiles(files);
    e.target.value = null;
  };

  const removeNew = (index) => {
    setNewImages((prev) => prev.filter((_, i) => i !== index));
    setNewPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    if (!catName.trim()) {
      setError('Kategori adı zorunludur.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      // Bu mahallede zaten var olan bir development item var mı?
      const existingItem = existingItems.length > 0 ? existingItems[0] : null;

      if (existingItem) {
        // Mevcut item'a yeni kategori ekle
        const detailResponse = await getNeighborhoodDevelopmentByGuid(existingItem.guid);
        if (!detailResponse?.isSuccess || !detailResponse.data) {
          throw new Error('Detay alınamadı.');
        }
        const fullItem = detailResponse.data;

        const existingCategories = (fullItem.categories || []).map((c, idx) => ({
          guid: c.guid,
          name: c.name,
          sokakName: c.sokakName || null,
          description: c.description || '',
          sortOrder: idx + 1,
          existingImageGuids: (c.images || []).map((img) => img.guid),
          galleryImagesBase64: []
        }));

        // Yeni kategoriyi ekle
        existingCategories.push({
          guid: null,
          name: catName.trim(),
          sokakName: sokakName || null,
          description: catDescription.trim(),
          sortOrder: existingCategories.length + 1,
          existingImageGuids: [],
          galleryImagesBase64: newImages
        });

        const payload = {
          guid: fullItem.guid,
          name: fullItem.name,
          sokakName: sokakName || fullItem.sokakName || null,
          urlTag: fullItem.urlTag,
          title: fullItem.title || '',
          description: fullItem.description || '',
          categories: existingCategories,
          existingImageGuids: [],
          galleryImagesBase64: [],
          isApproved: userRole === 'muhtar' ? false : (fullItem.isApproved ?? true),
          createdByRole: fullItem.createdByRole || userRole
        };

        const res = await updateNeighborhoodDevelopment(payload);
        if (res?.isSuccess) {
          onSuccess();
        } else {
          throw new Error(res?.resultMessage || 'Ekleme başarısız.');
        }
      } else {
        // Bu mahallede hiç development yoksa yeni oluştur
        const payload = {
          name: mahalleName,
          sokakName: sokakName || null,
          urlTag: generateSlug(mahalleName),
          title: '',
          description: '',
          coverImageBase64: null,
          categories: [{
            guid: null,
            name: catName.trim(),
            sokakName: sokakName || null,
            description: catDescription.trim(),
            sortOrder: 1,
            existingImageGuids: [],
            galleryImagesBase64: newImages
          }],
          galleryImagesBase64: [],
          isApproved: userRole === 'muhtar' ? false : true,
          createdByRole: userRole
        };

        const res = await addNeighborhoodDevelopment(payload);
        if (res?.isSuccess) {
          onSuccess();
        } else {
          throw new Error(res?.resultMessage || 'Ekleme başarısız.');
        }
      }
    } catch (err) {
      console.error(err);
      setError(err.message || 'Bir hata oluştu.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="mb-3 p-3 bg-light rounded">
        <small className="text-muted">Mahalle:</small>
        <div className="fw-bold">{mahalleName}</div>
      </div>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold">Kategori Adı <span className="text-danger">*</span></Form.Label>
            <Form.Control
              value={catName}
              onChange={(e) => setCatName(e.target.value)}
              placeholder="Örn: Asfalt Yama, Park Düzenleme"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label className="fw-semibold">Sokak / Cadde</Form.Label>
            <Form.Select value={sokakName} onChange={(e) => setSokakName(e.target.value)}>
              <option value="">-- Sokak Seçiniz (Opsiyonel) --</option>
              {streetOptions.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Açıklama</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          value={catDescription}
          onChange={(e) => setCatDescription(e.target.value)}
          placeholder="Opsiyonel kısa açıklama"
        />
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Label className="fw-bold text-dark small mb-1">Fotoğraflar Yükle</Form.Label>
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          className={`p-4 border border-2 border-dashed rounded-4 text-center transition-all ${
            isDragging ? 'bg-primary bg-opacity-10 border-primary shadow-sm' : 'bg-light border-secondary border-opacity-25'
          }`}
          style={{ transition: 'all 0.25s ease' }}
        >
          <Form.Control type="file" accept="image/*" multiple onChange={handleUpload} className="d-none" id="add-photo-upload" />
          <label htmlFor="add-photo-upload" className="mb-0 cursor-pointer d-flex flex-column align-items-center justify-content-center" style={{ cursor: 'pointer' }}>
            <FaCamera size={32} className={`mb-2 ${isDragging ? 'text-primary' : 'text-secondary'}`} />
            <span className="fw-bold text-dark small">
              {isDragging ? 'Fotoğrafları Buraya Bırakın' : 'Fotoğraf seçmek veya sürükleyip bırakmak için tıklayın'}
            </span>
            <small className="text-muted mt-1">Birden fazla görsele (PNG, JPG, WEBP) izin verilir</small>
          </label>
        </div>
      </Form.Group>

      {newPreviews.length > 0 && (
        <div className="mb-3">
          <div className="text-muted small mb-2 fw-semibold">Eklenecek Fotoğraflar ({newPreviews.length})</div>
          <div className="d-flex flex-wrap gap-2">
            {newPreviews.map((preview, idx) => (
              <div key={idx} className="position-relative border border-primary rounded p-1" style={{ width: 100, height: 100 }}>
                <Image src={preview} style={{ width: '100%', height: '100%', objectFit: 'cover' }} rounded />
                <Button
                  variant="danger" size="sm"
                  className="position-absolute top-0 end-0 m-1"
                  style={{ padding: '0 4px' }}
                  onClick={() => removeNew(idx)}
                >&times;</Button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
        <Button variant="secondary" onClick={onCancel} disabled={saving}>İptal</Button>
        <Button variant="primary" onClick={handleSave} disabled={saving}>
          {saving ? <Spinner animation="border" size="sm" /> : <><FaPlus className="me-2" /> Ekle</>}
        </Button>
      </div>
    </div>
  );
};

export default NeighborhoodList;
